import { CommonModule } from "@angular/common";
import { Component, Inject, OnDestroy, OnInit, Type } from "@angular/core";
import {
  ReactiveFormsModule,
  FormsModule,
  FormControl,
  Validators,
} from "@angular/forms";
import { MatButtonModule } from "@angular/material/button";
import { MatOptionModule } from "@angular/material/core";
import {
  MatDialogRef,
  MAT_DIALOG_DATA,
  MatDialogModule,
} from "@angular/material/dialog";
import { MatExpansionModule } from "@angular/material/expansion";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatIconModule } from "@angular/material/icon";
import { MatInputModule } from "@angular/material/input";
import { MatSelectModule } from "@angular/material/select";
import { MatTooltipModule } from "@angular/material/tooltip";
import { MatDatepickerModule } from "@angular/material/datepicker";
import {
  MaterialAttributes,
  MaterialStockAttributes,
  OrderAttributes,
} from "@albatrosdeveloper/ave-models-package";
import { StatusEnum } from '@albatrosdeveloper/ave-models-package/lib/enums';
import { MatSnackBar } from "@angular/material/snack-bar";
import { IUpdateOrder } from "../update-order/interfaces/update-order.interface";
import { UpdateOrderService } from "../update-order/update-order.service";
import { MaterialService } from "../../material/material/material.service";
import {
  debounceTime,
  lastValueFrom,
  ReplaySubject,
  Subject,
  switchMap,
  takeUntil,
} from "rxjs";
import { NgxMatSelectSearchModule } from "ngx-mat-select-search";
import { NgSelectModule } from "@ng-select/ng-select";
import { MatPaginatorIntl } from "@angular/material/paginator";
import { CustomMatPaginatorIntl } from "app/mock-api/common/customPaginatorIntl";
import AlternalUnitMeasurementAttributes from "@albatrosdeveloper/ave-models-package/lib/schemas/materials/material/alternal-unit-measure/alternal-unit-measure.entity";
import { OrderMaterialRequestFields } from "../quotation-generate/interfaces/fetch-sequence-materials-fields-request.interface";
import { environment } from "environments/environment.prod";
import { OrdersCreationService } from "../order-generate/order-generate.service";
import { PriceListResponse } from "./interfaces/price-list.interface";
import ReturnTypeAttributes from "@albatrosdeveloper/ave-models-package/lib/schemas/masters/return-type/return-type.entity";
import { ChangeConditionService } from "../../master/change-condition/change-condition.service";
import { ReasonRejectionService } from "../../master/reason-for-rejection/reason-rejection.service";
import ReasonRejectionAttributes from "@albatrosdeveloper/ave-models-package/lib/schemas/masters/reason-rejection/reason-rejection.entity";
import { TypeRejectEnum } from "../../shared/form-appro-reject/type-document.enum";
import { IRequestResult } from "app/common/interfaces";
import { DocumentTypeEnum } from "app/common/enums/document-types.enum";
import { HandlerMessageService } from "app/common/services/handler-error/handler-message.service";
import { FuseConfirmationService } from "@fuse/services/confirmation";

@Component({
  selector: "app-add-order-detail-modal",
  styleUrl: "./add-order-detail.component.scss",
  templateUrl: "./add-order-detail.component.html",
  standalone: true,
  imports: [
    CommonModule,
    MatDialogModule,
    MatButtonModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatSelectModule,
    MatOptionModule,
    MatTooltipModule,
    MatExpansionModule,
    MatDatepickerModule,
    MatButtonModule,
    MatIconModule,
    FormsModule,
    MatSelectModule,
    NgxMatSelectSearchModule,
    NgSelectModule,
  ],
  providers: [{ provide: MatPaginatorIntl, useClass: CustomMatPaginatorIntl }],
})
export class AddOrderDetailComponent implements OnInit, OnDestroy {
  isLoading: boolean = false;

  warehouseControl = new FormControl(null, Validators.required);
  warehouseRequired: boolean = true;
  warehouseDisabled: boolean = false;

  returnTypeControl = new FormControl(null, Validators.required);
  public returnTypeFilterControl: FormControl<string> = new FormControl<string>(
    ""
  );
  returnTypeRequired: boolean = true;
  returnTypeDisabled: boolean = false;
  returnTypeList: ReturnTypeAttributes[] = [];
  filteredReturnTypeList: ReplaySubject<ReturnTypeAttributes[]> = new ReplaySubject<
    ReturnTypeAttributes[]
  >(1);
  searchReturnType: string = null;

  materialControl = new FormControl(null, Validators.required);
  public materialFilterControl: FormControl<string> = new FormControl<string>(
    ""
  );
  materialRequired: boolean = true;
  materialDisabled: boolean = false;
  materialList: MaterialAttributes[] = [];
  filteredMaterialList: ReplaySubject<MaterialAttributes[]> = new ReplaySubject<
    MaterialAttributes[]
  >(1);
  searchMaterial: string = null;

  soldUnitOfMeasureControl = new FormControl(null, Validators.required);
  soldUnitOfMeasureRequired: boolean = true;
  soldUnitOfMeasureDisabled: boolean = false;
  soldUnitOfMeasureList: AlternalUnitMeasurementAttributes[] = [];

  soldQuantityControl = new FormControl(null, Validators.required);
  unitPriceControl = new FormControl(null);
  discountControl = new FormControl(null);
  conditionClassControl = new FormControl([]);
  protected _onDestroy = new Subject<void>();

  documentTypeToRejectEnum: Record<string, TypeRejectEnum> = {
    [DocumentTypeEnum.COTIZACION]: TypeRejectEnum.COTIZACION,
    [DocumentTypeEnum.PEDIDO]: TypeRejectEnum.PEDIDO,
    [DocumentTypeEnum.ENTREGA_ENTRADA]: TypeRejectEnum.ENTREGA,
    [DocumentTypeEnum.DOCUMENTO_DE_PAGO]: TypeRejectEnum.DOCUMENTO_PAGO,
    [DocumentTypeEnum.SOLICITUD_CAMBIO_PRODUCTO]: TypeRejectEnum.CAMBIO_PRODUCTO,
    [DocumentTypeEnum.SOLICITUD_DEVOLUCION_PRODUCTO]: TypeRejectEnum.DEVOLUCION_PRODUCTO,
    [DocumentTypeEnum.ENTREGA_SALIDA]: TypeRejectEnum.ENTREGA,
    [DocumentTypeEnum.CAMBIO_DE_PRODUCTO]: TypeRejectEnum.CAMBIO_PRODUCTO,
    [DocumentTypeEnum.DEVOLUCION_DE_PRODUCTO]: TypeRejectEnum.DEVOLUCION_PRODUCTO,
  };
  reasonRejectionControl = new FormControl(null, Validators.required)
  reasonRejectionList: ReasonRejectionAttributes[] = [];
  filteredReasonRejectionList = this.reasonRejectionList;
  searchReasonRejection: string = '';

  stock: MaterialStockAttributes[] = [];
  stockToValidate: number = 0;
  showCurrentStockForMaterials: boolean = false;
  ump : string =  '';


  validTypes = [DocumentTypeEnum.SOLICITUD_CAMBIO_PRODUCTO,DocumentTypeEnum.SOLICITUD_DEVOLUCION_PRODUCTO];
  isTypeValid: boolean = false;
  parallelQuantity: number = 0;

  constructor(
    private readonly updateOrderService: UpdateOrderService,
    private readonly materialService: MaterialService,
    private readonly changeConditionService: ChangeConditionService,
    private readonly ordersCreationService: OrdersCreationService,
    private readonly reasonRejectionService: ReasonRejectionService,
    private readonly handlerMessage: HandlerMessageService,
    private readonly fuseConfirmationService: FuseConfirmationService,
    public readonly dialogRef: MatDialogRef<AddOrderDetailComponent>,
    private snackBar: MatSnackBar,
    @Inject(MAT_DIALOG_DATA)
    public data: {
      order: OrderAttributes
      useRejectionMotive?: boolean
    }
  ) { }

  ngOnInit(): void {
    this.isTypeValid = this.isValidType(this.data.order.type.code);
    this.showCurrentStockForMaterials =
      this.data.order.class["showCurrentStockForMaterials"] ?? false;
    this.fetchMaterials();
    this.fetchAllChangeCondition();
    if(this.data.useRejectionMotive) this.fetchReasonRejections();
    this.soldQuantityControl.valueChanges.subscribe(() => {
      this.onQuantityParallelChange(); // recalcula en tiempo real
    });

    this.materialControl.valueChanges.subscribe(() => {
      this.onQuantityParallelChange(); // recalcula si cambia el material
    });
  }

  ngAfterViewInit(): void {
    // Escuchar cambios en el campo de búsqueda
    this.materialFilterControl.valueChanges
      .pipe(
        debounceTime(500),
        takeUntil(this._onDestroy),
        switchMap((searchTerm) => {
          const paginationOptions = {
            search: searchTerm
              ? searchTerm
              : this.materialControl.value
                ? this.materialControl.value.code
                : null,
            currentPage: 1,
            limitPerPage: 100,
          };
          return this.materialService.findToComboBox(paginationOptions);
        })
      )
      .subscribe({
        next: (res) => {
          this.materialList = res.data[0].data;
          this.filteredMaterialList.next(this.materialList);
        },
        error: (err) => {
          this.snackBar.open(
            err.error.message || "Error al filtrar los materiales.",
            "Cerrar",
            { duration: 3000 }
          );
        },
      });
  }

  isValidType(type: string): boolean {
    return this.validTypes.includes(type as DocumentTypeEnum);
  }

  private fetchAllChangeCondition(): void {
    let type: string = "";
    if(this.data.order.type.code== DocumentTypeEnum.SOLICITUD_CAMBIO_PRODUCTO){
      type='CP'
    } else if (this.data.order.type.code == DocumentTypeEnum.SOLICITUD_DEVOLUCION_PRODUCTO){
      type='DE'
    }
    this.changeConditionService.findToComboBox(type).subscribe({
      next: (res) => {
        this.returnTypeList = res.data;
        this.filteredReturnTypeList.next(this.returnTypeList);
      },
      error: (err) => {
        this.snackBar.open(err.error.message || "Error al obtener condiciones de cambio.","Cerrar",{ duration: 5000});
      },
    });
  }

  fetchMaterials(): void {
    // Llamada inicial con término vacío
    const paginationOptions = {
      search: " ",
      currentPage: 1,
      limitPerPage: 100,
    };

    // Realizamos la primera llamada al servidor para cargar los primeros 500 materiales
    this.materialService.findToComboBox(paginationOptions).subscribe({
      next: (res) => {
        this.materialList = res.data[0].data;
        this.filteredMaterialList.next(this.materialList);
      },
      error: (err) => {
        this.snackBar.open(
          err.error.message || "Error al obtener los materiales.",
          "Cerrar",
          { duration: 3000 }
        );
      },
    });
  }

  onMaterialChange(material: MaterialAttributes): void {
    this.unitPriceControl.setValue(null);
    this.soldUnitOfMeasureControl.setValue(null);
    this.soldUnitOfMeasureList = material.alternalUnitOfMeasures;
    this.discountControl.setValue(null);
    this.conditionClassControl.setValue([]);
    this.soldQuantityControl.setValue(null);
    this.stock = [];
    this.stockToValidate = 0;

    // Evalua si se puede autoseleccionar la unidad de medida
    this.soldUnitOfMeasureControl.setValue(null);
    if (
      material.baseUnitOfMeasure &&
      material.alternalUnitOfMeasures &&
      material.alternalUnitOfMeasures.length > 0
    ) {
      const alternalUMFound = material.alternalUnitOfMeasures.find(
        (aum) =>
          String(aum.unitOfMeasure._id) ==
          String(material.baseUnitOfMeasure._id)
      );
      if (alternalUMFound) {
        this.soldUnitOfMeasureControl.setValue(
          alternalUMFound.unitOfMeasure._id
        );
        this.getPrice();
      }
    }

    this.getStockByMaterial();
    this.onQuantityParallelChange();
  }

  onUnitOfMeasureChange(): void {
    const previousPrice = this.unitPriceControl.value;
    this.unitPriceControl.setValue(null);
    this.discountControl.setValue(null);
    this.conditionClassControl.setValue([]);
    this.soldQuantityControl.setValue(null);
    this.getPrice().then(() => {
      const newPrice = this.unitPriceControl.value;
      if (
        previousPrice != null &&
        newPrice != null &&
        Number(previousPrice) === Number(newPrice)
      ) {
        const currencyCode = this.data.order.currency?.name ?? '';
        const confirmation = this.fuseConfirmationService.open({
          title: 'Precio sin cambios',
          message: `El precio unitario se mantiene en ${newPrice} ${currencyCode} para la nueva unidad de medida. Si no es correcto, podría generar problemas en facturación y liquidación. Se recomienda validar con el personal encargado de las políticas comerciales.`,
          icon: {
            show: true,
            name: 'heroicons_outline:information-circle',
            color: 'info',
          },
          actions: {
            confirm: {
              label: 'Continuar',
              color: 'primary',
            },
            cancel: {
              show: false,
            },
          },
          dismissible: true,
        });
        confirmation.afterClosed().subscribe();
      }
    });
    this.getStockToValidate();
  }

  onWarehouseChange(): void {
    this.soldQuantityControl.setValue(null);
    this.getStockToValidate();
  }

  onQuantityChange(): void {
    if (
      this.data.order.class["makesStockValidation"] &&
      this.materialControl.value.canMakeAnOrderWithoutStock != true &&
      this.soldQuantityControl.value > this.stockToValidate
    ) {
      this.soldQuantityControl.setValue(this.stockToValidate);
      this.snackBar.open(
        "La cantidad no debe ser mayor al disponible.",
        "Cerrar",
        { duration: 3000 }
      );
    }
  }

  getPrice(): Promise<void> {
    this.unitPriceControl.setValue(null);
    let salesOrganizationId = this.data.order.distributionChain
      ? String(this.data.order.distributionChain.salesOrganization._id)
      : null;
    let soldToId = this.data.order.soldTo ? String(this.data.order.soldTo._id) : null;
    let shipToId = this.data.order.shipTo ? String(this.data.order.shipTo._id) : null;
    let priceListId =
      this.data.order.shipTo && this.data.order.shipTo.ownPriceList
        ? String(this.data.order.shipTo.ownPriceList._id)
        : null;
    let currencyId = this.data.order.currency ? String(this.data.order.currency._id) : null;
    let channelId = this.data.order.distributionChain
      ? String(this.data.order.distributionChain.channel._id)
      : null;

    let orderMaterialFields: OrderMaterialRequestFields = null;
    if (environment.projectName == "CORTIJO") {
      orderMaterialFields = {
        field1: salesOrganizationId,
        field3: shipToId,
        field4: priceListId,
        // field5: String(this.materialControl.value._id),
        // field6: String(this.soldUnitOfMeasureControl.value),
        field6: String(this.materialControl.value._id),
        field7: String(this.soldUnitOfMeasureControl.value),
        field14: soldToId,
        field15: this.data.order.salesOffice?._id.toString() ?? null,
        materials: [
          {
            materialId: String(this.materialControl.value._id),
            unitMeasureId: String(this.soldUnitOfMeasureControl.value),
          },
        ],
      };
    }
    if (environment.projectName == "DIUNSA") {
      orderMaterialFields = {
        field1: salesOrganizationId,
        field2: channelId,
        field3: soldToId,
        field4: priceListId,
        field5: currencyId,
        field6: this.materialControl.value._id,
        field7: this.soldUnitOfMeasureControl.value,
        materials: [
          {
            materialId: String(this.materialControl.value._id),
            unitMeasureId: String(this.soldUnitOfMeasureControl.value),
          },
        ],
      };
    }
    if (environment.projectName == 'PORTUGAL') {
      orderMaterialFields = {
        field1: salesOrganizationId,
        field4: priceListId,
        field5: currencyId,
        field6: this.materialControl.value._id,
        field7: this.soldUnitOfMeasureControl.value,
        materials: [
          {
            materialId: String(this.materialControl.value._id),
            unitMeasureId: String(this.soldUnitOfMeasureControl.value),
          },
        ],
      }
    }

    // Enviar los materiales al servicio
    return this.ordersCreationService
      .fetchPrice({ materials: [orderMaterialFields] })
      .toPromise()
      .then((res: PriceListResponse) => {
        this.unitPriceControl.setValue(res.materials[0]?.price ?? null);
        this.discountControl.setValue(res.materials[0]?.discount ?? null);
        this.conditionClassControl.setValue(
          res.materials[0]?.conditionClasses ?? []
        );
      })
      .catch((err) => {
        this.handlerMessage.error({
          message: err.error?.message,
          alternativeMessage: "Error al obtener el precio del material",
        });
      });
  }

  getRejectTypeFromServiceCode(serviceCode: string): TypeRejectEnum | null {
    return this.documentTypeToRejectEnum[serviceCode] ?? null;
  }

  fetchReasonRejections() {
    const rejectType = this.getRejectTypeFromServiceCode(this.data.order.type.code);

    if(!rejectType){ 
      this.snackBar.open("Motivo de rechazo no encontrado.","Cerrar",{ duration: 3000 });
      return;
    }

    this.reasonRejectionService.findToComboBox(rejectType).subscribe({
      next: (res: IRequestResult<ReasonRejectionAttributes[]>) => {
        this.reasonRejectionList = res.data;
        this.filteredReasonRejectionList = this.reasonRejectionList;
      },
      error: (err) => {
        this.snackBar.open(
          err.error.message || "Error al obtener los motivos de cancelación.","Cerrar",{ duration: 3000 }
        );
      },
    });
  }

  changueOptionRejection(event) {
    if (!this.reasonRejectionList) {
      return;
    }
    let search = event;
    if (!search) {
      this.filteredReasonRejectionList = this.reasonRejectionList.slice();
      return;
    } else {
      search = search.toLowerCase();
    }
    this.filteredReasonRejectionList = this.reasonRejectionList.filter(item => item.name.toLowerCase().indexOf(search) > -1)
  }

  onSave(): void {
    if (!this.soldQuantityControl.value || this.soldQuantityControl.value < 0)
      this.soldQuantityControl.setValue(0);
    if (!this.unitPriceControl.value || this.unitPriceControl.value < 0)
      this.unitPriceControl.setValue(0);

    if (this.unitPriceControl.value == 0) {
      this.snackBar.open("El precio no puede ser 0.", "Cerrar", {
        duration: 3000,
      });
      return;
    }
    this.isLoading = true;
    const dataToUpdate: IUpdateOrder = {
      detail: [
        {
          position: null,
          materialId: String(this.materialControl.value._id),
          warehouseId: String(this.warehouseControl.value),
          soldUnitOfMeasureId: String(this.soldUnitOfMeasureControl.value),
          returnTypeId: this.isTypeValid && this.returnTypeControl ? String(this.returnTypeControl.value?._id) : null,
          soldQuantity: this.soldQuantityControl.value,
          unitPrice: this.unitPriceControl.value,
          priceConditionClasses: this.conditionClassControl.value.map((c) => ({
            ...c,
            value: String(c.value),
          })),
        },
      ],
    };

    this.updateOrderService
      .updateOrder(String(this.data.order._id), dataToUpdate)
      .subscribe({
        next: (res) => {
          this.snackBar.open(
            this.data.order.type.code == DocumentTypeEnum.COTIZACION
              ? "Cotización actualizada con éxito."
              : "Pedido actualizado con éxito.",
            "Cerrar",
            {
              duration: 3000,
            }
          );
          this.isLoading = false;
          this.dialogRef.close({
            data: res.data,
            reasonRejection: this.reasonRejectionControl.value
          });
        },
        error: (err) => {
          this.isLoading = false;
          this.snackBar.open(
            err.error.message ||
            (this.data.order.type.code == DocumentTypeEnum.COTIZACION
              ? "Error al actualizar la cotización."
              : "Error al actualizar el pedido."),
            "Cerrar",
            { duration: 3000 }
          );
        },
      });
  }

  isDisabledMaterial(material: MaterialAttributes): boolean {
    return this.data.order.detail.some(
      (od) =>
        od.statusId == StatusEnum.ACTIVE && String(od.material._id) == String(material._id)
    );
  }

  compareById(item1: any, item2: any): boolean {
    return item1 && item2 ? item1._id === item2._id : item1 === item2;
  }

  async getStockByMaterial(): Promise<void> {
    this.stock = [];
    let dataToSend = {
      materialsIds: [String(this.materialControl.value._id)],
      warehouseIds:
        this.data.order["warehousesToUpdate"]?.map((w) => String(w._id)) ?? [],
    };
    this.stock = await lastValueFrom(
      this.ordersCreationService.fetchStock(dataToSend)
    ).then((res) => res.data[0].data);
    if (this.warehouseControl.value) this.getStockToValidate();
  }

  getStockToValidate(): void {
    this.stockToValidate = 0;
    if (!this.materialControl.value) return;
    if (!this.warehouseControl.value) return;
    if (!this.soldUnitOfMeasureControl.value) return;

    const unitOfMeasureFound: AlternalUnitMeasurementAttributes =
      this.materialControl.value.alternalUnitOfMeasures?.find(
        (uma) =>
          String(uma.unitOfMeasure._id) ==
          String(this.soldUnitOfMeasureControl.value)
      ) ?? null;
    if (!unitOfMeasureFound) return;

    const dateToValidate = new Date();
    dateToValidate.setMonth(
      dateToValidate.getMonth() +
      (this.data.order.company["totalMonthsToGroupStockInRouting"] ?? 0)
    );
    this.stockToValidate = this.roundToX(
      (this.data.order.company["groupStockByDateInRouting"] == true
        ? this.stock
          .filter(
            (s: MaterialStockAttributes) =>
              String(s.warehouseId) == String(this.warehouseControl.value) &&
              s.lotExpirationDate &&
              new Date(s.lotExpirationDate).getTime() >=
              dateToValidate.getTime()
          )
          .reduce((acc, s) => acc + s.availableStock, 0)
        : this.stock.find(
          (s) => String(s.warehouseId) == String(this.warehouseControl.value)
        )?.availableStock ?? 0) / unitOfMeasureFound.conversionFactor,
      unitOfMeasureFound.unitOfMeasure.hasacceptedDecimals
        ? unitOfMeasureFound.unitOfMeasure.decimalsAllowed
        : 0
    );
  }

  roundToX(value: number, decimals: number) {
    return parseFloat(value.toFixed(decimals));
  }

  ngOnDestroy(): void {
    this._onDestroy.next();
    this._onDestroy.complete();
  }

  onQuantityParallelChange(): void {
    const quantity = this.soldQuantityControl.value;
    const factor = this.getConversionFactor();
    this.parallelQuantity = quantity && factor ? quantity / factor : 0;
    this.parallelQuantity = this.roundToX(this.parallelQuantity,3)
  }

  getConversionFactor(): number {
    const material = this.materialControl.value;
    if (!material?.alternalUnitOfMeasures) return 1;

    const altUom = material.alternalUnitOfMeasures.find(uom => uom.isUMP);
    this.ump = altUom.unitOfMeasure.code;

    return altUom?.conversionFactor || 1;
  }



}
